export const jwtConfig = {
  fetchUrl: "http://117.17.198.44:8080"
};

export const jwtLocalStorageVariableName = "tcpWebJwt";
